import { useState, useEffect } from 'react';
import { reportScreen } from '../../services/analyticsService';
import { Page } from '../../components/layout';
import ContentHeader from '../../components/ContentHeader';
import { TABS, TABS_CONFIG } from './constants';

import './index.scss';

const SettingsPage = () => {
  const [selectedTab, setSelectedTab] = useState(TABS.ACCOUNT);

  useEffect(() => {
    reportScreen('settings_page');
  }, []);

  const handleTabClick = (tab) => {
    setSelectedTab(tab);
  };

  const renderContent = () => {
    const activeTab = TABS_CONFIG.find((tab) => tab.key === selectedTab);
    return activeTab?.component || null;
  };

  return (
    <Page className="settings-page">
      <ContentHeader title="Settings" />
      <div className="deals-tabs">
        {TABS_CONFIG.map((tab) => (
          <div
            key={tab.key}
            className={`deals-tabs-item ${
              selectedTab === tab.key ? 'active' : ''
            }`}
            onClick={() => handleTabClick(tab.key)}
          >
            <span>{tab.label}</span>
          </div>
        ))}
      </div>
      <div className="tab-content">{renderContent()}</div>
    </Page>
  );
};

export default SettingsPage;
